import { render } from "./CarouselIndicators.vue?vue&type=template&id=e0add766"
import script from "./CarouselIndicators.vue?vue&type=script&lang=js"
export * from "./CarouselIndicators.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/CarouselIndicators.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0add766"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0add766', __exports__)) {
    api.reload('e0add766', __exports__)
  }
  
  module.hot.accept("./CarouselIndicators.vue?vue&type=template&id=e0add766", () => {
    api.rerender('e0add766', render)
  })

}


export default __exports__